import Circle from './circle.vue';

export default Circle;



// WEBPACK FOOTER //
// ./src/components/circle/index.js